<template>
  <span>
    <!-- grid search -->
    <v-row>
      <v-col :cols="disabled?12:6">
        <v-text-field
          v-model="keyword"
          append-icon="mdi-magnify"
          label="Cari"
          hide-details
          single-line
          clearable
        ></v-text-field>
      </v-col>
      <!-- form rincian transaksi -->
      <v-col cols="6" class="text-right" v-if="!disabled">
        <v-btn class="ml-2 mt-2" color="primary" outlined @click="addItem">
          <span class="hidden-xs-only">Tambah</span>
          <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-plus-box</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" persistent max-width="300px">
          <ValidateAll ref="form">
            <v-form>
              <v-card>
                <v-card-title>Rincian Pajak</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="dialog-form">
                  <Validate name="Jenis pajak" rules="fully_required" #default="{ errors }">
                    <v-select
                      :error-messages="errors"
                      hide-details="auto"
                      v-model="item.Pajak"
                      :items="list.pajak.data"
                      item-text="Nama"
                      item-value="IDPajak"
                      label="Jenis pajak"
                      return-object
                    >
                      <template v-slot:item="data">{{data.item.Nama}}</template>
                      <template v-slot:selection="data">{{data.item.Nama}}</template>
                    </v-select>
                  </Validate>
                  <br />
                  <Validate name="Nominal" rules="required|min_value:1" #default="{ errors }">
                    <v-text-field
                      :error-messages="errors"
                      hide-details="auto"
                      v-model="item.Nominal"
                      label="Nominal"
                      placeholder="Nominal"
                      type="number"
                    ></v-text-field>
                  </Validate>
                  <br />
                  <v-textarea
                    v-model="item.Keterangan"
                    no-resize
                    rows="2"
                    name="Keterangan"
                    label="Keterangan"
                    placeholder="Keterangan"
                  ></v-textarea>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn color="secondary" text @click="dialog = false">Batal</v-btn>
                  <v-spacer />
                  <v-btn color="primary" text @click="saveItem">Simpan</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </ValidateAll>
        </v-dialog>
      </v-col>
    </v-row>
    <br />
    <v-row>
      <v-col cols="12" class="px-0 py-0">
        <v-divider />
        <v-data-table
          :headers="headers"
          :items="value"
          :loading="loading"
          :loading-text="app.grid.loading"
          :no-data-text="app.grid.noData"
          :search="keyword"
          multi-sort
          hide-default-footer
        >
          <!-- custom updated date & by -->
          <template v-slot:item.Nominal="{ item }">{{item.Nominal | currency}}</template>
          <template v-slot:item.LastUpdatedDate="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span dark v-on="on">{{$format.relativeUpdatedDate(item)}}</span>
              </template>
              <span>{{$format.updatedDate(item)}}</span>
            </v-tooltip>
          </template>

          <!-- grid actions -->
          <template v-slot:item.Actions="{ item }" v-if="!disabled">
            <div v-if="!item.ETLID" class="float-right">
              <v-btn class="mr-4" icon color="blue" @click="editItem(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" :loading="item.processing">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="deleteItem(item)">
                    <v-list-item-icon>
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>Hapus</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </span>
</template>

<style lang="scss">
</style>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { clone } from "lodash";

export default {
  name: "rincian-pajak",
  props: {
    value: Array,
    loading: Boolean,
    disabled: Boolean
  },
  data: () => ({
    proto: {
      uid: "",
      IDPajak: "",
      Pajak: {},
      Nama: "",
      Nominal: 0,
      Keterangan: "",
      CreatedDate: new Date(),
      LastUpdatedDate: new Date()
    },
    dialog: false,
    keyword: "",
    item: {},
    items: [],
    headers: [
      {
        value: "Nama",
        text: "Pajak",
        width: "30%"
      },
      {
        value: "Nominal",
        text: "Nominal",
        width: "20%"
      },
      {
        value: "Keterangan",
        text: "Keterangan",
        width: "25%"
      },
      {
        value: "LastUpdatedDate",
        text: "Terakhir Diubah",
        width: "15%"
      },
      {
        value: "Actions",
        sortable: false,
        width: "15%"
      }
    ]
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", ["isPajakLoading"])
  },
  methods: {
    ...mapActions("list", ["refreshPajak"]),
    addItem() {
      this.item = Object.assign({}, this.proto);
      this.item.uid = this.$util.uid();
      if (this.$refs.form) this.$refs.form.reset();
      this.dialog = true;
    },
    editItem(item) {
      if (this.$refs.form) this.$refs.form.reset();
      this.item = clone(this.preProcessItem(item));
      this.dialog = true;
    },
    async saveItem() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      if (this.item.ID) this.item.LastUpdatedDate = new Date();
      else this.item.CreatedDate = new Date();

      this.item = this.preProcessItem(this.item);
      let index = this.value.findIndex(x => x.uid == this.item.uid);

      if (index == -1) this.value.push(this.item);
      else this.$set(this.value, index, this.item);
      this.dialog = false;
    },
    preProcessItem(item) {
      item.Nominal = parseFloat(item.Nominal);
      return item;
    },
    async deleteItem(item) {
      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menghapus data ?"
      });
      if (confirmation) {
        let index = this.value.findIndex(x => x.uid == item.uid);
        if (index > -1) this.value.splice(index, 1);
      }
    }
  },
  watch: {
    "item.Pajak"(v) {
      if (!this.$util.isEmpty(v)) {
        this.item.Nama = v.Nama;
        this.item.IDPajak = v.IDPajak;
      }
    }
  }
};
</script>

